import React, { useMemo } from "react";
import "./catalog-game.scss";
import GameDesk from "./games-desk/GameDesk";
import { getSliceForCarousel } from "../../../utils/utils";
import Providers from "../providers/Providers";
import ErrorBoundary from "../../mui/error_boundary/ErrorBoundary";
import { useAppSelector } from "../../../store/index.ts";
import useFillHistories from "../../../hooks/common/useFillHistories.js";
import { GAME_COUNT } from "../../../store/enums.js";

export default function CatalogGame() {
  const getSlice = getSliceForCarousel;
  useFillHistories(GAME_COUNT);

  const categoryList = useAppSelector((state) => state.games.categoryList);
  const historyS = useAppSelector((state) => state.games.runningGames);

  const history = useMemo(() => getSlice(historyS, 2) || [], [historyS]);

  return (
    <section className="catalog-game">
      <div className="catalog-game__content">
        <ErrorBoundary>
          {categoryList.map((category) => {
            const items = getSlice(category.games, 2);

            return (
              <ErrorBoundary key={category.id}>
                <GameDesk
                  showAllLink={"/categories/" + category.id}
                  title={category.name}
                  items={items}
                  row2={items.length > 16}
                />
              </ErrorBoundary>
            );
          })}
        </ErrorBoundary>

        <ErrorBoundary>
          <Providers />
        </ErrorBoundary>

        <ErrorBoundary>
          <GameDesk
            id={"history"}
            showAllLink={"/games/history"}
            title={"History Games"}
            items={history}
          />
        </ErrorBoundary>
      </div>
    </section>
  );
}
